// @ts-nocheck
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { PagesCollectionModel } from "@insite/client-framework/Services/ContentService";
import { PageModel } from "@insite/client-framework/Types/PageProps";
import { getBlog } from "@store/Framework/Services/RslBlogService";
import { getBlogListFilters } from "@store/Framework/Store/Store/Pages/BlogList/BlogListSelector";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

export interface GetBlogApiParameter extends ApiParameter {
    sortBy: string;
    isArchived: boolean;
    category?: string;
    pageSize?: number;
}
export interface GetBlogWithFiltersApiParameter extends GetBlogApiParameter {
    getFilters?: boolean;
}

export interface BlogListFiltersModel {
    categories: string[];
    hasArchive: boolean;
}

export interface BlogListResultModel {
    blogList: PagesCollectionModel;
    filters?: BlogListFiltersModel;
}

export interface BlogListApiResultModel {
    blogList: PageModel[];
    filters?: BlogListFiltersModel;
}

type HandlerType = ApiHandler<
    GetBlogApiParameter & HasOnSuccess<BlogListResultModel> & HasOnError,
    BlogListResultModel
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const state = props.getState();

    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });

    const blogListFilters = getBlogListFilters(state);
    let apiParameter: GetBlogWithFiltersApiParameter = props.apiParameter;
    if (!blogListFilters) {
        // first time getting the list, we also want the filters
        apiParameter = { ...props.apiParameter, getFilters: true };
    }

    props.apiResult = await getBlog(apiParameter);
    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: props.apiResult.blogList,
        links: state.links,
        ...getContextData(state),
    });
    if (props.apiResult.filters) {
        props.dispatch({
            type: "Store/Pages/BlogList/GetFiltersComplete",
            parameter: props.apiResult.filters,
        });
    }
};

export const CallOnSuccess: HandlerType = props => {
    if (props.apiResult) {
        props.apiParameter.onSuccess?.(props.apiResult);
    }
};

export const CallOnError: HandlerType = props => {
    if (!props.apiResult) {
        props.apiParameter.onError?.();
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, CallOnSuccess, CallOnError];

const getBlogList = createHandlerChainRunner(chain, "GetBlogList");
export default getBlogList;
